import { Typography } from '@material-ui/core';
import React from 'react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { SubTitle } from 'styles/Form/SubTitle';

interface FinalStageProps {
  title: string | null;
  body: string | null;
}

const Body = styled.p`
  font-size: 14px;
  text-align: center;
  margin: 15px;
  color: #444444;
`;

export const FinalStage: FC<FinalStageProps> = ({ title, body }) => {
  const { t } = useTranslation();
  if (title == null && body == null)
    return <SubTitle>{t('thankYouForFeedback')}</SubTitle>;
  return (
    <div>
      <SubTitle>{title}</SubTitle>
      <Body>{body}</Body>
    </div>
  );
};
